import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import {
  obtenerBrandingTiendaSetup,
  actualizarBrandingTiendaSetup,
} from "../../../services/usuarios_tienda/tiendaSetup";
import {
  IconLogin,
  IconCart,
  IconWhatsapp,
  IconFacebook,
  IconInstagram,
  IconMail,
} from "../../../icons/Icons";
import { fileURL } from "../../../utils/fileURL";
import "../../../components/store/StoreHeader.css";
import "../../../components/store/Footer.css";
import "./TabBranding.css";

const PREVIEW_HEADER_LOGO_DEFAULT = "/image/cyravi-default-logo.png";
const PREVIEW_FOOTER_LOGO_DEFAULT = "/image/cyravi-default-logo.png";

const PREVIEW_HEADER_CATEGORIAS = [
  { id: 1, nombre: "Electrónica" },
  { id: 2, nombre: "Hogar y deco", active: true },
  { id: 3, nombre: "Moda" },
  { id: 4, nombre: "Belleza" },
  { id: 5, nombre: "Deportes" },
  { id: 6, nombre: "Juguetería" },
  { id: 7, nombre: "Librería" },
  { id: 8, nombre: "Mascotas" },
];

const PREVIEW_HEADER_SUBS = [
  { id: 101, nombre: "Audio" },
  { id: 102, nombre: "Cables y accesorios" },
  { id: 103, nombre: "Iluminación" },
  { id: 104, nombre: "Cocina" },
  { id: 105, nombre: "Decoración" },
  { id: 106, nombre: "Muebles" },
  { id: 107, nombre: "Textil" },
  { id: 108, nombre: "Jardín" },
];

const PREVIEW_HEADER_MARCAS = [
  "Nike",
  "Adidas",
  "Puma",
  "Reebok",
  "New Balance",
  "Asics",
  "Fila",
  "Converse",
  "Vans",
  "Under Armour",
];

export const BRANDING_FIELDS = [
  ["slogan", "Slogan"],
  ["texto", "Texto"],
  ["color_primario", "Color primario"],
  ["color_secundario", "Color secundario"],
  ["color_texto_primario", "Texto primario"],
  ["color_texto_secundario", "Texto secundario"],
  ["color_texto_terciario", "Texto terciario"],
  ["color_texto_contraste", "Texto contraste"],
  ["color_borde_primario", "Borde primario"],
  ["color_borde_fuerte", "Borde fuerte"],
  ["color_fondo_primario", "Fondo primario"],
  ["color_fondo_secundario", "Fondo secundario"],
  ["color_fondo_terciario", "Fondo terciario"],
  ["color_fondo_cuaternario", "Fondo cuaternario"],
  ["color_fondo_quinario", "Fondo quinario"],
  ["color_fondo_senario", "Fondo senario"],
  ["color_resplandor_izquierdo", "Resplandor izquierdo"],
  ["color_resplandor_derecho", "Resplandor derecho"],
  ["color_anillo_enfoque", "Anillo enfoque"],
  ["sombra_suave", "Sombra suave"],
  ["sombra_principal", "Sombra principal"],
  ["sombra_boton_primario", "Sombra botón primario"],
  ["sombra_boton_primario_hover", "Sombra botón primario hover"],
];

export const TEXT_KEYS = new Set(["slogan", "texto"]);
export const COLOR_KEYS = new Set(
  BRANDING_FIELDS.map(([k]) => k).filter((k) => k.startsWith("color_"))
);

const TEMA_HEADER_FALLBACK = {
  color_primario: "#1f2937",
  color_secundario: "#475569",
  color_texto_primario: "#0f172a",
  color_texto_secundario: "#475569",
  color_texto_terciario: "#64748b",
  color_texto_contraste: "#ffffff",
  color_borde_primario: "rgba(148, 163, 184, 0.22)",
  color_borde_fuerte: "rgba(100, 116, 139, 0.26)",
  color_fondo_primario: "#ffffff",
  color_fondo_secundario: "#f8fafc",
  color_fondo_terciario: "#f1f5f9",
  color_fondo_cuaternario: "#eef2f7",
  color_fondo_quinario: "#e2e8f0",
  color_fondo_senario: "rgba(15, 23, 42, 0.04)",
  color_resplandor_izquierdo: "rgba(148, 163, 184, 0.18)",
  color_resplandor_derecho: "rgba(203, 213, 225, 0.16)",
  color_anillo_enfoque: "rgba(15, 23, 42, 0.12)",
  sombra_suave: "0 6px 18px rgba(15, 23, 42, 0.05)",
  sombra_principal: "0 12px 40px rgba(15, 23, 42, 0.08)",
  sombra_boton_primario: "0 4px 14px rgba(15, 23, 42, 0.12)",
  sombra_boton_primario_hover: "0 6px 18px rgba(15, 23, 42, 0.16)",
};

const COLOR_TEXTO_PELIGRO_FALLBACK = "#be123c";

const TEMA_FOOTER_FALLBACK = {
  color_primario: "#818cf8",
  color_secundario: "#22d3ee",
  color_texto_primario: "#a5b4fc",
  color_texto_secundario: "#f1f5f9",
  color_texto_terciario: "#94a3b8",
  color_texto_contraste: "#ffffff",
  color_borde_primario: "rgba(248, 250, 252, 0.08)",
  color_borde_fuerte: "rgba(248, 250, 252, 0.16)",
  color_fondo_primario: "#0f172a",
  color_fondo_secundario: "#1e293b",
  color_fondo_terciario: "rgba(255, 255, 255, 0.05)",
  color_fondo_cuaternario: "rgba(99, 102, 241, 0.12)",
  color_fondo_quinario: "rgba(34, 211, 238, 0.08)",
  color_fondo_senario: "rgba(15, 23, 42, 0.6)",
  color_resplandor_izquierdo: "rgba(99, 102, 241, 0.15)",
  color_resplandor_derecho: "rgba(34, 211, 238, 0.12)",
  color_anillo_enfoque: "rgba(129, 140, 248, 0.35)",
  sombra_suave: "0 12px 32px rgba(0, 0, 0, 0.35)",
  sombra_principal: "0 24px 48px rgba(0, 0, 0, 0.45)",
  sombra_boton_primario: "0 8px 24px rgba(99, 102, 241, 0.45)",
  sombra_boton_primario_hover: "0 12px 28px rgba(99, 102, 241, 0.55)",
};

function pickTema(row, fallback, activeKeys = null) {
  const out = { ...fallback };
  for (const k of Object.keys(fallback)) {
    if (activeKeys != null && !activeKeys.has(k)) continue;
    const v = row[k];
    const t = String(v ?? "").trim();
    if (t) out[k] = t;
  }
  return out;
}

/** Solo las claves editables en el inspector deben afectar la vista previa. */
export function buildPreviewActiveKeys({
  usaCatalogo,
  catalogoSel,
  code,
  colorFields,
  shadowFields,
  textFields,
}) {
  const keys = new Set();
  if (usaCatalogo) {
    catalogoSel.forEach((v) => keys.add(v.clave));
  } else {
    colorFields.forEach(([k]) => keys.add(k));
    shadowFields.forEach(([k]) => keys.add(k));
  }
  if (code !== "HEADER" && code !== "FOOTER") {
    textFields.forEach(([k]) => keys.add(k));
  }
  return keys;
}

export function normalizeHexForPicker(raw) {
  const s = String(raw ?? "").trim();
  if (/^#[0-9A-Fa-f]{6}$/.test(s)) return s;
  if (/^#[0-9A-Fa-f]{3}$/.test(s)) {
    const r = s[1];
    const g = s[2];
    const b = s[3];
    return `#${r}${r}${g}${g}${b}${b}`;
  }
  return "#888888";
}

export function isHexColorString(s) {
  const t = String(s ?? "").trim();
  return /^#([0-9A-Fa-f]{3}|[0-9A-Fa-f]{6})$/.test(t);
}

export function seccionCodigoDe(row) {
  return String(row?.seccion_codigo || "")
    .trim()
    .toUpperCase();
}

function emptyBrandingRow(sec) {
  const row = {
    tienda_branding_id: null,
    tienda_id: null,
    seccion_branding_id: Number(sec.seccion_branding_id),
    seccion_codigo: sec.codigo,
    seccion_nombre: sec.nombre,
  };
  BRANDING_FIELDS.forEach(([key]) => {
    row[key] = "";
  });
  return row;
}

function mergeSeccionesBranding(secciones, branding) {
  const bySid = new Map(
    (branding || []).map((b) => [Number(b.seccion_branding_id), b])
  );
  return (secciones || []).map((s) => {
    const sid = Number(s.seccion_branding_id);
    const ex = bySid.get(sid);
    if (ex) {
      return {
        ...ex,
        seccion_codigo: String(ex.seccion_codigo ?? s.codigo ?? ""),
        seccion_nombre: String(ex.seccion_nombre ?? s.nombre ?? ""),
      };
    }
    return emptyBrandingRow(s);
  });
}

export function parseBrandingResponse(data) {
  if (!data) return { workingRows: [], seccionesCatalogo: [] };

  if (Array.isArray(data.secciones) && data.branding !== undefined) {
    const secciones = data.secciones;
    const workingRows = mergeSeccionesBranding(secciones, data.branding);
    return { workingRows, seccionesCatalogo: secciones };
  }

  if (Array.isArray(data)) {
    const branding = data;
    const seen = new Map();
    branding.forEach((r) => {
      const sid = Number(r.seccion_branding_id);
      if (!Number.isFinite(sid)) return;
      if (!seen.has(sid)) {
        seen.set(sid, {
          seccion_branding_id: r.seccion_branding_id,
          codigo: r.seccion_codigo,
          nombre: r.seccion_nombre || r.seccion_codigo || `Sección ${sid}`,
        });
      }
    });
    const pseudo = Array.from(seen.values());
    return {
      workingRows: pseudo.length ? mergeSeccionesBranding(pseudo, branding) : branding,
      seccionesCatalogo: pseudo,
    };
  }

  return { workingRows: [], seccionesCatalogo: [] };
}

function rowToHeaderThemeVars(row, activeKeys = null) {
  const t = pickTema(row, TEMA_HEADER_FALLBACK, activeKeys);
  return {
    "--sh-color-primario": t.color_primario,
    "--sh-color-secundario": t.color_secundario,
    "--sh-color-texto-primario": t.color_texto_primario,
    "--sh-color-texto-secundario": t.color_texto_secundario,
    "--sh-color-texto-terciario": t.color_texto_terciario,
    "--sh-color-texto-contraste": t.color_texto_contraste,
    "--sh-color-peligro": COLOR_TEXTO_PELIGRO_FALLBACK,
    "--sh-color-borde-primario": t.color_borde_primario,
    "--sh-color-borde-fuerte": t.color_borde_fuerte,
    "--sh-color-fondo-primario": t.color_fondo_primario,
    "--sh-color-fondo-secundario": t.color_fondo_secundario,
    "--sh-color-fondo-terciario": t.color_fondo_terciario,
    "--sh-color-fondo-cuaternario": t.color_fondo_cuaternario,
    "--sh-color-fondo-quinario": t.color_fondo_quinario,
    "--sh-color-fondo-senario": t.color_fondo_senario,
    "--sh-color-resplandor-izquierdo": t.color_resplandor_izquierdo,
    "--sh-color-resplandor-derecho": t.color_resplandor_derecho,
    "--sh-color-anillo-enfoque": t.color_anillo_enfoque,
    "--sh-sombra-suave": t.sombra_suave,
    "--sh-sombra-principal": t.sombra_principal,
    "--sh-sombra-boton-primario": t.sombra_boton_primario,
    "--sh-sombra-boton-primario-hover": t.sombra_boton_primario_hover,
  };
}

function rowToFooterStyleVars(row, activeKeys = null) {
  const t = pickTema(row, TEMA_FOOTER_FALLBACK, activeKeys);
  return {
    "--sf-powered-by-from": t.color_primario,
    "--sf-powered-by-to": t.color_secundario,
    "--sf-color-primario": t.color_primario,
    "--sf-color-secundario": t.color_secundario,
    "--sf-color-texto-primario": t.color_texto_primario,
    "--sf-color-texto-secundario": t.color_texto_secundario,
    "--sf-color-texto-terciario": t.color_texto_terciario,
    "--sf-color-texto-contraste": t.color_texto_contraste,
    "--sf-color-borde-primario": t.color_borde_primario,
    "--sf-color-borde-fuerte": t.color_borde_fuerte,
    "--sf-color-fondo-primario": t.color_fondo_primario,
    "--sf-color-fondo-secundario": t.color_fondo_secundario,
    "--sf-color-fondo-terciario": t.color_fondo_terciario,
    "--sf-color-fondo-cuaternario": t.color_fondo_cuaternario,
    "--sf-color-fondo-quinario": t.color_fondo_quinario,
    "--sf-color-fondo-senario": t.color_fondo_senario,
    "--sf-color-resplandor-izquierdo": t.color_resplandor_izquierdo,
    "--sf-color-resplandor-derecho": t.color_resplandor_derecho,
    "--sf-color-anillo-enfoque": t.color_anillo_enfoque,
    "--sf-sombra-suave": t.sombra_suave,
    "--sf-sombra-principal": t.sombra_principal,
    "--sf-sombra-boton-primario": t.sombra_boton_primario,
    "--sf-sombra-boton-primario-hover": t.sombra_boton_primario_hover,
  };
}

function previewHeaderLogoError(e) {
  if (e.currentTarget.dataset.fallbackApplied === "1") return;
  e.currentTarget.dataset.fallbackApplied = "1";
  e.currentTarget.src = PREVIEW_HEADER_LOGO_DEFAULT;
}

// Limpia un valor de color para incrustarlo de forma segura dentro de un <style>.
function sanitizeCssColor(value) {
  return String(value ?? "").replace(/[^a-zA-Z0-9#(),.%\s/-]/g, "");
}

function BrandingPreviewHeader({ row, logoUrl, activeKeys = null }) {
  const themeVars = rowToHeaderThemeVars(row, activeKeys);
  // Los scrollbars WebKit no se repintan al cambiar una var() CSS en vivo, así
  // que inyectamos el color literal. Usamos el COLOR DE ACENTO (color_primario)
  // — el morado de la marca, que siempre está poblado — igual que el frontend,
  // para que el scroll se vea morado en el editor y coincida exactamente.
  const acento = sanitizeCssColor(
    String(row?.color_primario ?? "").trim() ||
      themeVars["--sh-color-primario"] ||
      "#6d5efc"
  );
  const scrollThumb = `color-mix(in srgb, ${acento} 45%, transparent)`;
  const scrollThumbHover = `color-mix(in srgb, ${acento} 78%, transparent)`;
  const scrollCss = `
    .tsb-store-mock--header .cyravi-fh__mega-scroll {
      scrollbar-width: thin;
      scrollbar-color: ${scrollThumb} transparent;
    }
    .tsb-store-mock--header .cyravi-fh__mega-scroll::-webkit-scrollbar {
      width: 9px;
    }
    .tsb-store-mock--header .cyravi-fh__mega-scroll::-webkit-scrollbar-track {
      background: transparent;
      margin: 6px 0;
    }
    .tsb-store-mock--header .cyravi-fh__mega-scroll::-webkit-scrollbar-thumb {
      background: ${scrollThumb} !important;
      border: 2px solid transparent;
      background-clip: padding-box;
      border-radius: 999px;
    }
    .tsb-store-mock--header .cyravi-fh__mega-scroll::-webkit-scrollbar-thumb:hover {
      background: ${scrollThumbHover} !important;
      border: 2px solid transparent;
      background-clip: padding-box;
      border-radius: 999px;
    }
  `;
  const logoSrc =
    fileURL(logoUrl) ||
    fileURL(PREVIEW_HEADER_LOGO_DEFAULT) ||
    PREVIEW_HEADER_LOGO_DEFAULT;
  const activeCat =
    PREVIEW_HEADER_CATEGORIAS.find((c) => c.active) || PREVIEW_HEADER_CATEGORIAS[0];

  return (
    <div className="tsb-store-mock tsb-store-mock--header tsb-chrome">
      <style>{scrollCss}</style>
      <div className="cyravi-StoreHeader" style={themeVars}>
        <header className="cyravi-fh">
          <div className="cyravi-fh__stack">
            <div className="cyravi-fh__primary">
              <div className="cyravi-fh__primary-inner">
                <div className="cyravi-fh__row cyravi-fh__row--top">
                  <div className="cyravi-fh__brand" aria-hidden="true">
                    <img
                      src={logoSrc}
                      className="cyravi-fh__logo"
                      alt=""
                      onError={previewHeaderLogoError}
                    />
                  </div>

                  <div className="cyravi-fh__search-block">
                    <div className="cyravi-fh__search-shell">
                      <span className="cyravi-fh__search-icon">⌕</span>
                      <input
                        readOnly
                        tabIndex={-1}
                        className="cyravi-fh__search-input"
                        placeholder="Buscar productos…"
                        value=""
                        aria-hidden="true"
                      />
                    </div>
                  </div>

                  <div className="cyravi-fh__actions">
                    <button type="button" className="cyravi-fh__action-btn" tabIndex={-1}>
                      <span className="cyravi-fh__action-ico">{IconLogin}</span>
                      <span className="cyravi-fh__action-label">Mi cuenta</span>
                    </button>
                    <button
                      type="button"
                      className="cyravi-fh__action-btn cyravi-fh__cart-btn"
                      tabIndex={-1}
                    >
                      <span className="cyravi-fh__action-ico">{IconCart}</span>
                      <span className="cyravi-fh__action-label">Carrito</span>
                    </button>
                    <button
                      type="button"
                      className="cyravi-fh__menu-btn"
                      aria-hidden="true"
                      tabIndex={-1}
                    >
                      <span />
                      <span />
                      <span />
                    </button>
                  </div>
                </div>

                <div className="cyravi-fh__nav-row">
                  <nav className="cyravi-fh__nav" aria-label="Vista previa (solo diseño)">
                    <button type="button" className="cyravi-fh__nav-link" tabIndex={-1}>
                      Inicio
                    </button>

                    <div className="cyravi-fh__nav-item">
                      <button
                        type="button"
                        className="cyravi-fh__nav-link is-active"
                        tabIndex={-1}
                      >
                        Explorar
                      </button>
                    </div>

                    <div className="cyravi-fh__nav-item">
                      <button type="button" className="cyravi-fh__nav-link" tabIndex={-1}>
                        Marcas
                      </button>
                    </div>

                    <button type="button" className="cyravi-fh__nav-link" tabIndex={-1}>
                      Ofertas
                    </button>
                  </nav>
                </div>

                <div className="tsb-fh-preview-mega">
                  <div className="cyravi-fh__mega-menu cyravi-fh__mega-menu--explore">
                    <div className="cyravi-fh__mega-explore-grid">
                      <div className="cyravi-fh__mega-explore-pair">
                        <div className="cyravi-fh__mega-col cyravi-fh__mega-col--categories">
                          <h4 className="cyravi-fh__mega-title">Categorías</h4>
                          <div className="cyravi-fh__mega-scroll">
                            {PREVIEW_HEADER_CATEGORIAS.map((cat) => (
                              <button
                                key={cat.id}
                                type="button"
                                className={`cyravi-fh__mega-category${
                                  cat.active ? " is-active" : ""
                                }`}
                                tabIndex={-1}
                              >
                                {cat.nombre}
                              </button>
                            ))}
                          </div>
                        </div>
                        <div className="cyravi-fh__mega-col cyravi-fh__mega-col--subcategories">
                          <h4 className="cyravi-fh__mega-title">Subcategorías</h4>
                          <div className="cyravi-fh__mega-scroll">
                            {PREVIEW_HEADER_SUBS.map((sub) => (
                              <button
                                key={sub.id}
                                type="button"
                                className="cyravi-fh__mega-subcategory"
                                tabIndex={-1}
                              >
                                {sub.nombre}
                              </button>
                            ))}
                          </div>
                        </div>
                      </div>
                      <aside className="cyravi-fh__mega-aside">
                        <p className="cyravi-fh__mega-kicker">Explorar</p>
                        <h3 className="cyravi-fh__mega-heading">Catálogo de productos</h3>
                        <p className="cyravi-fh__mega-aside-meta">
                          Categoría: <strong>{activeCat.nombre}</strong>
                        </p>
                        <button type="button" className="cyravi-fh__mega-cta" tabIndex={-1}>
                          Ver todos los productos
                        </button>
                      </aside>
                    </div>
                  </div>
                </div>

                <div className="tsb-fh-preview-brands">
                  <div className="cyravi-fh__mega-menu cyravi-fh__mega-menu--brands">
                    <div className="cyravi-fh__mega-brands-grid">
                      <div className="cyravi-fh__mega-brands-col">
                        <h4 className="cyravi-fh__mega-title">Marcas</h4>
                        <div className="cyravi-fh__mega-scroll">
                          {PREVIEW_HEADER_MARCAS.map((nombre, idx) => (
                            <button
                              key={nombre}
                              type="button"
                              className={`cyravi-fh__mega-category${
                                idx === 0 ? " is-active" : ""
                              }`}
                              tabIndex={-1}
                            >
                              {nombre}
                            </button>
                          ))}
                        </div>
                      </div>
                      <aside className="cyravi-fh__mega-aside">
                        <p className="cyravi-fh__mega-kicker">Marcas</p>
                        <h3 className="cyravi-fh__mega-heading">Productos por fabricante</h3>
                        <button type="button" className="cyravi-fh__mega-cta" tabIndex={-1}>
                          Ver todos los productos
                        </button>
                      </aside>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </header>
      </div>
    </div>
  );
}

function previewFooterLogoError(e) {
  if (e.currentTarget.dataset.fallbackApplied === "1") return;
  e.currentTarget.dataset.fallbackApplied = "1";
  e.currentTarget.src = PREVIEW_FOOTER_LOGO_DEFAULT;
}

function BrandingPreviewFooter({ row, logoUrl, activeKeys = null }) {
  const footerStyleVars = rowToFooterStyleVars(row, activeKeys);
  const defaultSlogan = "Descripción o slogan de tu tienda";
  const defaultNombre = "Nombre de tu tienda";
  const slogan =
    activeKeys != null && !activeKeys.has("slogan")
      ? defaultSlogan
      : String(row?.slogan || "").trim() || defaultSlogan;
  const nombreTienda =
    activeKeys != null && !activeKeys.has("texto")
      ? defaultNombre
      : String(row?.texto || "").trim() || defaultNombre;
  const logoSrc =
    fileURL(logoUrl) ||
    fileURL(PREVIEW_FOOTER_LOGO_DEFAULT) ||
    PREVIEW_FOOTER_LOGO_DEFAULT;
  const year = new Date().getFullYear();

  return (
    <div className="tsb-store-mock tsb-store-mock--footer tsb-chrome">
      <div className="cyravi-footer-scope" style={footerStyleVars}>
        <footer className="cyravi-footer">
          <div className="cyravi-footer__inner">
            <div className="cyravi-footer__main">
              <div className="cyravi-footer__brand">
                <img
                  className="cyravi-footer__logo"
                  src={logoSrc}
                  alt=""
                  onError={previewFooterLogoError}
                />
                <p className="cyravi-footer__desc">{slogan}</p>
              </div>

              <div className="cyravi-footer__info-stack">
                <nav
                  className="cyravi-footer__legal-col"
                  aria-label="Información (vista previa)"
                >
                  <span className="cyravi-footer__col-title">Información</span>
                  <div className="cyravi-footer__legal-links">
                    <span className="cyravi-footer__legal-link">Términos y condiciones</span>
                    <span className="cyravi-footer__legal-link">Política de privacidad</span>
                    <span className="cyravi-footer__legal-link">Envíos y devoluciones</span>
                  </div>
                </nav>

                <section
                  className="cyravi-footer__pagos-col"
                  aria-label="Métodos de pago (ejemplo)"
                >
                  <span className="cyravi-footer__col-title">Métodos de pago</span>
                  <ul className="cyravi-footer__pagos-list">
                    <li>Tarjeta débito / crédito</li>
                    <li>Transferencia bancaria</li>
                    <li>Pago contra entrega</li>
                  </ul>
                </section>
              </div>

              <div className="cyravi-footer__side">
                <div className="cyravi-footer__card">
                  <div className="cyravi-footer__card-head">
                    <span className="cyravi-footer__card-kicker">Contacto</span>
                    <h4>Canales de contacto</h4>
                  </div>
                  <div className="cyravi-footer__socials">
                    <span className="cyravi-footer__social" data-canal="WHATSAPP">
                      <span className="cyravi-footer__icon-box">{IconWhatsapp}</span>
                      <span className="cyravi-footer__social-copy">
                        <span className="cyravi-footer__social-platform">WHATSAPP</span>
                        <span className="cyravi-footer__social-name">Venta en línea</span>
                      </span>
                    </span>
                    <span className="cyravi-footer__social" data-canal="EMAIL">
                      <span className="cyravi-footer__icon-box">{IconMail}</span>
                      <span className="cyravi-footer__social-copy">
                        <span className="cyravi-footer__social-platform">EMAIL</span>
                        <span className="cyravi-footer__social-name">hola@ejemplo.com</span>
                      </span>
                    </span>
                  </div>
                </div>

                <div className="cyravi-footer__card">
                  <div className="cyravi-footer__card-head">
                    <span className="cyravi-footer__card-kicker">Social</span>
                    <h4>Síguenos</h4>
                  </div>
                  <div className="cyravi-footer__socials">
                    <span
                      className="cyravi-footer__social"
                      data-canal="FACEBOOK"
                      data-social="facebook"
                    >
                      <span className="cyravi-footer__icon-box">{IconFacebook}</span>
                      <span className="cyravi-footer__social-copy">
                        <span className="cyravi-footer__social-platform">FACEBOOK</span>
                        <span className="cyravi-footer__social-name">/tu-tienda</span>
                      </span>
                    </span>
                    <span
                      className="cyravi-footer__social"
                      data-canal="INSTAGRAM"
                      data-social="instagram"
                    >
                      <span className="cyravi-footer__icon-box">{IconInstagram}</span>
                      <span className="cyravi-footer__social-copy">
                        <span className="cyravi-footer__social-platform">INSTAGRAM</span>
                        <span className="cyravi-footer__social-name">@tu_tienda</span>
                      </span>
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div className="cyravi-footer__bottom">
              <span>
                © {year} {nombreTienda}
              </span>
              <span className="cyravi-footer__dot">•</span>
              <span>
                Powered by <span className="cyravi-footer__powered">cyravi</span>
              </span>
            </div>
          </div>
        </footer>
      </div>
      <p className="tsb-mock-caption">Vista estática del pie (sin enlaces activos)</p>
    </div>
  );
}

function BrandingPreviewGeneric({ row, activeKeys = null }) {
  const t = pickTema(row, TEMA_HEADER_FALLBACK, activeKeys);
  return (
    <div
      className="tsb-pg"
      style={{
        "--pg-f1": t.color_fondo_primario,
        "--pg-f2": t.color_fondo_secundario,
        "--pg-borde": t.color_borde_primario,
        "--pg-sh": t.sombra_suave,
      }}
    >
      <p
        style={{
          margin: "0 0 10px",
          fontSize: 11,
          fontWeight: 800,
          color: t.color_texto_primario,
        }}
      >
        Muestra de paleta
      </p>
      <div className="tsb-pg__sw">
        <span style={{ background: t.color_primario }} title="Primario" />
        <span style={{ background: t.color_secundario }} title="Secundario" />
        <span style={{ background: t.color_texto_secundario }} title="Texto sec." />
        <span style={{ background: t.color_fondo_terciario }} title="Fondo ter." />
        <span style={{ background: t.color_fondo_cuaternario }} title="Fondo cuat." />
      </div>
    </div>
  );
}

export function BrandingPreview({ row, logoUrl, activeKeys = null }) {
  const code = seccionCodigoDe(row);
  if (code === "HEADER") {
    return <BrandingPreviewHeader row={row} logoUrl={logoUrl} activeKeys={activeKeys} />;
  }
  if (code === "FOOTER") {
    return <BrandingPreviewFooter row={row} logoUrl={logoUrl} activeKeys={activeKeys} />;
  }
  return <BrandingPreviewGeneric row={row} activeKeys={activeKeys} />;
}

export function getSectionDescription(code) {
  switch (code) {
    case "HEADER":
      return "Define la identidad visual del encabezado, navegación y acciones principales.";
    case "FOOTER":
      return "Controla la presentación visual de la parte inferior, enlaces y contacto.";
    default:
      return "Configura la identidad visual general de esta sección.";
  }
}

function SetupTabBranding() {
  const [workingRows, setWorkingRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState(null);
  const [selectedSeccionId, setSelectedSeccionId] = useState(null);
  const [catalogo, setCatalogo] = useState([]);
  const [search, setSearch] = useState("");
  const [openGroups, setOpenGroups] = useState(() => new Set());
  const baselineRef = useRef({});

  const load = useCallback(async () => {
    setLoading(true);
    setMsg(null);

    const res = await obtenerBrandingTiendaSetup();

    if (res.ok && res.data !== undefined) {
      const { workingRows: next, seccionesCatalogo } = parseBrandingResponse(res.data);

      // Catálogo de tokens + valores EAV de la tienda.
      const cat = Array.isArray(res.data.catalogo) ? res.data.catalogo : [];
      const vals = Array.isArray(res.data.valores) ? res.data.valores : [];
      const vmap = new Map(vals.map((v) => [Number(v.branding_variable_id), v.valor]));

      // Para secciones con catálogo, el valor EAV (o el default del catálogo) es la
      // fuente de verdad: se siembra en el row para el editor y la vista previa.
      const catBySec = new Map();
      cat.forEach((v) => {
        const s = Number(v.seccion_branding_id);
        if (!catBySec.has(s)) catBySec.set(s, []);
        catBySec.get(s).push(v);
      });
      const seeded = next.map((row) => {
        const list = catBySec.get(Number(row.seccion_branding_id));
        if (!list || !list.length) return row;
        const r = { ...row };
        list.forEach((v) => {
          const propio = vmap.get(Number(v.branding_variable_id));
          r[v.clave] =
            propio != null && String(propio).trim() !== ""
              ? propio
              : v.valor_default ?? r[v.clave] ?? "";
        });
        return r;
      });

      // Snapshot base para detectar cambios sin guardar.
      const base = {};
      seeded.forEach((r) => {
        const snap = {};
        BRANDING_FIELDS.forEach(([k]) => {
          snap[k] = r[k] ?? "";
        });
        base[Number(r.seccion_branding_id)] = snap;
      });
      baselineRef.current = base;

      setCatalogo(cat);
      setWorkingRows(seeded);
      const firstId = next.length ? Number(next[0].seccion_branding_id) : null;
      const fallback = seccionesCatalogo.length && firstId != null ? firstId : null;

      setSelectedSeccionId((prev) => {
        if (prev != null && next.some((r) => Number(r.seccion_branding_id) === prev)) {
          return prev;
        }
        return fallback;
      });
    } else {
      setMsg({ type: "err", text: res.message });
      setWorkingRows([]);
      setSelectedSeccionId(null);
    }

    setLoading(false);
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  useEffect(() => {
    if (!workingRows.length) return;
    const ids = workingRows.map((r) => Number(r.seccion_branding_id));
    if (selectedSeccionId == null || !ids.includes(Number(selectedSeccionId))) {
      setSelectedSeccionId(ids[0]);
    }
  }, [workingRows, selectedSeccionId]);

  // Al cambiar de sección (o al cargar el catálogo), abre todos sus grupos.
  useEffect(() => {
    const grupos = catalogo
      .filter((v) => Number(v.seccion_branding_id) === Number(selectedSeccionId))
      .map((v) => v.grupo);
    setOpenGroups(new Set(grupos));
    setSearch("");
  }, [selectedSeccionId, catalogo]);

  const patchRow = (seccionId, field, value) => {
    setWorkingRows((prev) =>
      prev.map((r) =>
        Number(r.seccion_branding_id) === Number(seccionId)
          ? { ...r, [field]: value }
          : r
      )
    );
  };

  const toggleGroup = (g) =>
    setOpenGroups((prev) => {
      const n = new Set(prev);
      if (n.has(g)) n.delete(g);
      else n.add(g);
      return n;
    });

  const restaurarGrupo = (vars) =>
    vars.forEach((v) => patchRow(selectedSeccionId, v.clave, v.valor_default ?? ""));

  const guardar = async () => {
    const row = workingRows.find(
      (r) => Number(r.seccion_branding_id) === Number(selectedSeccionId)
    );

    if (!row) {
      setMsg({ type: "err", text: "Seleccioná una sección." });
      return;
    }

    setSaving(true);
    setMsg(null);

    const item = { seccion_branding_id: Number(row.seccion_branding_id) };

    BRANDING_FIELDS.forEach(([key]) => {
      item[key] = row[key];
    });

    const tid = Number(row.tienda_branding_id);
    if (Number.isInteger(tid) && tid > 0) {
      item.tienda_branding_id = tid;
    }

    const payload = { branding: [item] };

    // Si la sección usa catálogo (HEADER), guardamos también los valores EAV.
    const catSel = catalogo.filter(
      (v) => Number(v.seccion_branding_id) === Number(row.seccion_branding_id)
    );
    if (catSel.length) {
      payload.valores = catSel.map((v) => ({
        branding_variable_id: v.branding_variable_id,
        valor: row[v.clave] ?? "",
      }));
    }

    const res = await actualizarBrandingTiendaSetup(payload);

    if (res.ok) {
      setMsg({
        type: "ok",
        text: res.message || (tid > 0 ? "Branding actualizado." : "Branding creado."),
      });
      await load();
    } else {
      setMsg({ type: "err", text: res.message });
    }

    setSaving(false);
  };

  const selectedRow = workingRows.find(
    (r) => Number(r.seccion_branding_id) === Number(selectedSeccionId)
  );

  const tienePersistido = selectedRow && Number(selectedRow.tienda_branding_id) > 0;

  // Variables del catálogo para la sección seleccionada (HEADER en fase 1).
  const catalogoSel = useMemo(
    () =>
      catalogo
        .filter((v) => Number(v.seccion_branding_id) === Number(selectedSeccionId))
        .slice()
        .sort((a, b) => (a.orden || 0) - (b.orden || 0)),
    [catalogo, selectedSeccionId]
  );
  const usaCatalogo = catalogoSel.length > 0;
  const gruposCatalogo = useMemo(() => {
    const m = new Map();
    catalogoSel.forEach((v) => {
      if (!m.has(v.grupo)) m.set(v.grupo, []);
      m.get(v.grupo).push(v);
    });
    return Array.from(m.entries());
  }, [catalogoSel]);

  const isSearching = search.trim() !== "";
  const gruposFiltrados = useMemo(() => {
    if (!isSearching) return gruposCatalogo;
    const q = search.trim().toLowerCase();
    return gruposCatalogo
      .map(([g, vars]) => [
        g,
        vars.filter(
          (v) =>
            String(v.etiqueta).toLowerCase().includes(q) ||
            String(v.clave).toLowerCase().includes(q) ||
            String(g).toLowerCase().includes(q)
        ),
      ])
      .filter(([, vars]) => vars.length);
  }, [gruposCatalogo, isSearching, search]);

  // Cambios sin guardar de la sección seleccionada (compara con el snapshot base).
  const dirty = useMemo(() => {
    if (!selectedRow) return false;
    const base = baselineRef.current[Number(selectedSeccionId)] || {};
    return BRANDING_FIELDS.some(([k]) => (base[k] ?? "") !== (selectedRow[k] ?? ""));
  }, [selectedRow, selectedSeccionId]);

  const textFields = useMemo(
    () => BRANDING_FIELDS.filter(([key]) => TEXT_KEYS.has(key)),
    []
  );

  const colorFields = useMemo(
    () => BRANDING_FIELDS.filter(([key]) => COLOR_KEYS.has(key)),
    []
  );

  const shadowFields = useMemo(
    () => BRANDING_FIELDS.filter(
      ([key]) => !TEXT_KEYS.has(key) && !COLOR_KEYS.has(key)
    ),
    []
  );
  const selectedCode = selectedRow ? seccionCodigoDe(selectedRow) : "";
  const previewActiveKeys = useMemo(
    () =>
      buildPreviewActiveKeys({
        usaCatalogo,
        catalogoSel,
        code: selectedCode,
        colorFields,
        shadowFields,
        textFields,
      }),
    [usaCatalogo, catalogoSel, selectedCode, colorFields, shadowFields, textFields]
  );

  const renderField = (key, label, hint, resetTo) => {
    if (!selectedRow || selectedSeccionId == null) return null;
    const sid = selectedSeccionId;
    const puedeRestaurar = resetTo != null && (selectedRow[key] ?? "") !== resetTo;
    const labelRow = (
      <div className="tsb-field__labelrow">
        <label htmlFor={`br-${key}`} className="tsb-field__label">
          {label}
        </label>
        {puedeRestaurar && (
          <button
            type="button"
            className="tsb-field__reset"
            onClick={() => patchRow(sid, key, resetTo)}
            title="Restaurar al valor por defecto"
          >
            ↺ Restaurar
          </button>
        )}
      </div>
    );

    if (TEXT_KEYS.has(key)) {
      return (
        <div className="tsb-field" key={key}>
          <label htmlFor={`br-${key}`} className="tsb-field__label">
            {label}
          </label>
          <input
            id={`br-${key}`}
            className="tsb-input"
            value={selectedRow[key] ?? ""}
            onChange={(e) => patchRow(sid, key, e.target.value)}
            placeholder={key === "slogan" ? "Escribe un slogan" : "Escribe un texto"}
          />
        </div>
      );
    }

    if (COLOR_KEYS.has(key)) {
      const val = selectedRow[key] ?? "";
      const hexOk = isHexColorString(val);

      return (
        <div className="tsb-field" key={key}>
          {labelRow}
          <div className="tsb-color-row">
            <input
              id={`br-${key}`}
              className="tsb-input"
              type="text"
              value={val}
              onChange={(e) => patchRow(sid, key, e.target.value)}
              placeholder="#RRGGBB o rgba(...)"
              spellCheck={false}
            />
            <input
              type="color"
              className="tsb-color-swatch"
              value={hexOk ? normalizeHexForPicker(val) : "#888888"}
              disabled={!hexOk && String(val).trim() !== ""}
              title={hexOk ? "Elegir color" : "Solo valores #hex; edita el texto para rgba"}
              aria-label={`Selector de color: ${label}`}
              onChange={(e) => patchRow(sid, key, e.target.value)}
            />
          </div>
          {hint && <span className="tsb-field__hint">{hint}</span>}
        </div>
      );
    }

    return (
      <div className="tsb-field" key={key}>
        {labelRow}
        <input
          id={`br-${key}`}
          className="tsb-input"
          value={selectedRow[key] ?? ""}
          onChange={(e) => patchRow(sid, key, e.target.value)}
          placeholder="0 12px 24px rgba(...)"
        />
        {hint && <span className="tsb-field__hint">{hint}</span>}
      </div>
    );
  };

  if (loading) {
    return <div className="tienda-setup-loading">Cargando…</div>;
  }

  if (!workingRows.length) {
    return (
      <div className="tienda-setup-empty">
        No hay secciones de branding configuradas en el catálogo. Revisá la tabla{" "}
        <code>seccion_branding</code>.
      </div>
    );
  }

  return (
    <div className="tsb-page2">
      <div className="tsb-topbar">
        <div className="tsb-topbar__intro">
          <p className="tsb-topbar__eyebrow">Diseño</p>
          <h2 className="tsb-topbar__title">Diseño de tu tienda</h2>
          <p className="tsb-topbar__desc">
            Elige una sección, personaliza sus colores y mira el resultado en vivo.
          </p>
        </div>

        <div className="tsb-tabs" role="tablist" aria-label="Secciones">
          {workingRows.map((row) => {
            const sid = Number(row.seccion_branding_id);
            const code = seccionCodigoDe(row);
            const active = sid === Number(selectedSeccionId);
            const name = String(row.seccion_nombre || "").trim() || code || "Sección";
            return (
              <button
                key={sid}
                type="button"
                role="tab"
                aria-selected={active}
                className={`tsb-tab${active ? " is-active" : ""}`}
                onClick={() => setSelectedSeccionId(sid)}
              >
                {name}
              </button>
            );
          })}
        </div>
      </div>

      <div className="tsb-split">
          <aside className="tsb-preview">
            <div className="tsb-preview-card">
              <div className="tsb-preview-card__head">
                <div>
                  <p className="tsb-preview-card__eyebrow">Vista previa</p>
                  <h3 className="tsb-preview-card__title">Cómo se ve en la tienda</h3>
                </div>
                <div className="tsb-preview-card__pill">
                  {selectedRow
                    ? seccionCodigoDe(selectedRow) || "GENERAL"
                    : "PREVIEW"}
                </div>
              </div>

              <div className="tsb-preview-card__frame">
                <div className="tsb-preview-device">
                  <div className="tsb-preview-device__top" aria-hidden>
                    <span />
                    <span />
                    <span />
                  </div>
                  <div className="tsb-preview-viewport" tabIndex={0}>
                    <div className="tsb-preview-surface">
                      {selectedRow && (
                        <BrandingPreview
                          row={selectedRow}
                          activeKeys={previewActiveKeys}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </aside>

          <main className="tsb-editor">
            {selectedRow && (
              <>
                <div className="tsb-editor-header">
                  <div>
                    <p className="tsb-editor-header__eyebrow">
                      {seccionCodigoDe(selectedRow) || "SECCIÓN"}
                    </p>
                    <h3 className="tsb-editor-header__title">
                      {String(selectedRow.seccion_nombre || "").trim() ||
                        seccionCodigoDe(selectedRow) ||
                        "Sección"}
                    </h3>
                    <p className="tsb-editor-header__desc">
                      {getSectionDescription(seccionCodigoDe(selectedRow))}
                    </p>
                  </div>

                  <div className="tsb-editor-header__badge">
                    {tienePersistido ? "Configuración existente" : "Pendiente de crear"}
                  </div>
                </div>

                <div className="tsb-editor-grid">
                  {usaCatalogo && (
                    <div className="tsb-toolbar">
                      <span className="tsb-toolbar__icon" aria-hidden>⌕</span>
                      <input
                        className="tsb-toolbar__search"
                        placeholder="Buscar variable… (ej. fondo, acento, sombra)"
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                      />
                      {isSearching && (
                        <button
                          type="button"
                          className="tsb-toolbar__clear"
                          onClick={() => setSearch("")}
                        >
                          Limpiar
                        </button>
                      )}
                    </div>
                  )}

                  {usaCatalogo ? (
                    gruposFiltrados.length === 0 ? (
                      <p className="tsb-empty-search">
                        No hay variables que coincidan con “{search}”.
                      </p>
                    ) : (
                      gruposFiltrados.map(([grupo, vars]) => {
                        const abierto = isSearching || openGroups.has(grupo);
                        return (
                          <section className="tsb-card tsb-group" key={grupo}>
                            <div className="tsb-group__head">
                              <button
                                type="button"
                                className="tsb-group__toggle"
                                onClick={() => toggleGroup(grupo)}
                                aria-expanded={abierto}
                              >
                                <span className={`tsb-group__chev${abierto ? " is-open" : ""}`} aria-hidden>
                                  ▸
                                </span>
                                <h3>{grupo}</h3>
                                <span className="tsb-group__count">{vars.length}</span>
                              </button>
                              <button
                                type="button"
                                className="tsb-group__reset"
                                onClick={() => restaurarGrupo(vars)}
                                title="Restaurar este grupo a sus valores por defecto"
                              >
                                Restaurar
                              </button>
                            </div>
                            {abierto && (
                              <div
                                className={`tsb-card__body${
                                  vars.some((v) => v.tipo === "color")
                                    ? " tsb-card__body--colors"
                                    : ""
                                }`}
                              >
                                {vars.map((v) =>
                                  renderField(v.clave, v.etiqueta, v.descripcion, v.valor_default)
                                )}
                              </div>
                            )}
                          </section>
                        );
                      })
                    )
                  ) : (
                    <>
                      <section className="tsb-card tsb-card--colors">
                        <div className="tsb-card__head">
                          <h3>Colores</h3>
                          <span>{colorFields.length} campos</span>
                        </div>
                        <div className="tsb-card__body tsb-card__body--colors">
                          {colorFields.map(([key, label]) => renderField(key, label))}
                        </div>
                      </section>

                      <section className="tsb-card">
                        <div className="tsb-card__head">
                          <h3>Sombras</h3>
                          <span>{shadowFields.length} campos</span>
                        </div>
                        <div className="tsb-card__body">
                          {shadowFields.map(([key, label]) => renderField(key, label))}
                        </div>
                      </section>
                    </>
                  )}

                  <section className="tsb-card">
                    <div className="tsb-card__head">
                      <h3>Contenido</h3>
                      <span>{textFields.length} campos</span>
                    </div>
                    <div className="tsb-card__body">
                      {textFields.map(([key, label]) => renderField(key, label))}
                    </div>
                  </section>
                </div>

                <div className={`tsb-savebar${dirty ? " is-dirty" : ""}`}>
                  <span className="tsb-savebar__status">
                    {dirty ? "Tienes cambios sin guardar" : "Todo guardado"}
                  </span>
                  {msg && (
                    <span
                      className={`tsb-savebar__msg tsb-savebar__msg--${
                        msg.type === "ok" ? "ok" : "err"
                      }`}
                    >
                      {msg.text}
                    </span>
                  )}
                  <button
                    type="button"
                    className="tsb-btn-primary tsb-savebar__btn"
                    disabled={saving || (usaCatalogo && !dirty)}
                    onClick={guardar}
                  >
                    {saving
                      ? "Guardando…"
                      : tienePersistido
                      ? "Guardar cambios"
                      : "Crear branding"}
                  </button>
                </div>
              </>
            )}
          </main>
        </div>
    </div>
  );
}

export default SetupTabBranding;